module.exports = __webpack_public_path__ + "static/syntheseyeserreport-fde5fe8bc4a0e7de31342aee419f5b45.pdf";